import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import {List} from 'material-ui/List';
import swal from 'sweetalert';
import {notify} from 'react-notify-toast';
import moment from 'moment';

var Config = require('../../../config');

class ModalVitalSigns extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		//this.autoHandleChange = this.autoHandleChange.bind(this);
		this.saveVitalSigns = this.saveVitalSigns.bind(this);
		this.printSvDocument = this.printSvDocument.bind(this);
		this.acceptNum = this.acceptNum.bind(this);

		this.state = {
			donor_name:"",
			donor_sex:"",
			offer_number:"",
			offer_date:"",
		    show: false,
			item: {},
			biometrics:[],  

			incident:{
				key:"",
				text:""
			},
			incident_type:{
				id:"",
				text:""
			},
			incidents_category:[],
			disable_incidents_cat : false,
			incidents_type:[],
			incident_refused_id:"",
			caller_id:"",
			option:'',
			max_length:"4",
			isExtractionComplete: false, 
		};
	}

	componentDidMount() {
		this.props.onRef(this);

		// incident category lookups?type=incident_type&notRender=0
		fetch(Config.default.apiGateway.URL+'lookups?type=incident_type&notRender=0',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				incidents_category: response
			})

			this.selectIncident();

		})
	}

	//selecciona extraction por defecto
	selectIncident(){
		this.state.incidents_category.map(function(i){
			
			if(i.key === 'INCIDENT_SVITALES'){
				const incident = this.state.incident;
				incident.key   = i.key;
				incident.text = i.name;

				this.setState({
					incident:incident,
					disable_incidents_cat:true
				});

				this.getIncidentType(i.key);
			}
		}.bind(this));
	}

	getIncidentType = (key)=>{
		fetch(Config.default.apiGateway.URL+'incidents?option='+key, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				incidents_type:response
			})
		})
	}

	onIncidentSelected = (e)=>{
		//this.handleChange(e);
		
		const incident = this.state[e.target.name];	

		if(e.target.name === 'incident'){
			incident.key   = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text

			this.setState({
				incident : incident
			});
			this.getIncidentType(e.target.value);
		
		}else{
			incident.id    = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text

			this.setState({
				incident_type : incident
			});
		}
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false,item:{} });
	}

	handleShow(id,donor, caller_id, isExtractionComplete) {
		this.setState({ 
			show: true,
			offer_id:id,
			biometrics:[],
			item:{},
			caller_id:caller_id,
			donor_id:donor,
			isExtractionComplete: isExtractionComplete
		});

		
		this.getDonor(donor);
	}

	getDonor(id){
		//donor
		fetch(Config.default.apiGateway.URL+'donors/basic_info/'+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({donor_sex: response.sex });

			this.getVitalSigns(response.sex);
		})
	}

	//get vital signs
	getVitalSigns(sex){
		
		fetch(Config.default.apiGateway.URL+'biometrics?option=BIO_F_SIGNOS&sex='+sex,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	    	for (var i = 0; i < response.length; i++) {
		      	response[i].offer_id = this.state.offer_id;
		    };

	      	this.setState({biometrics: response});
	      	setTimeout(function() { //Start the timer
			  	this.getVitalSignsData();
			  	for(var j =0;j<response.length;j++){
			  		document.getElementById(response[j].id).required = response[j].required;
			  	}
			}.bind(this), 500);
			
	    })
	}

	getVitalSignsData(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'biometrics_data/by_offer?id='+this.state.offer_id+'&form_type=BIO_F_SIGNOS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => {
	    	this.props.waiting.handleClose();
	    	if(response.ok){
	    		return response.json()
	    	}
	    })
	    .then(response => {
			console.log(response);
			var values = response.values;
			this.setState({
				sample_valid:response.sample_valid
			});

	    	if(response.incident_id !== undefined){
	    		this.setState({
    				incident_type:{
    					id:response.incident_id
    				}
    			});
	    	}
    		if(response.incident !== null && response.incident !== undefined){
    			this.setState({
    				incident_refused_id:response.incident.id
    			});
    		}
	      	for(var i =0; i < values.length;i++){
				if (this.state.biometrics[i].data_type=="BIO_D_SELECT") {
					document.getElementById(values[i].biometrics_id).value = values[i].value_text;
				}else{
	      		document.getElementById(values[i].biometrics_id).value = parseFloat(values[i].value);
				this.validateRangeSV(values[i].biometrics_id,values[i].value)
				}
	      	}

	      	if(values.length > 0){
	      		this.setState({option:'update'});
	      	}else{
	      		this.setState({option:'save'});
	      	}

			this.setState({
				donor_name:response.donor_name,
				offer_number:response.offer_id,
				offer_date:moment(response.timestamp_date).format('DD/MM/YYYY')
			});
	      	if(this.props.task_vital_signs.create && this.props.task_vital_signs.update){
	      		this.setState({option:'todos'});
	      	}
	    });
	}


	getTerms(term){
		var result = "";
		var formula = "";
		for (var i = 0; i < term.length; i++) {
			var id = parseFloat( term[i] );
			//console.log(id)
			if (!isNaN(id)) {
				if (this.getItemValue(id).indexOf('.') < 0){
					if (i==1 ||i===3 || i===5){
						formula = formula + (this.getItemValue(id)/100);
					}
					else{
						//console.log(formula,"i",i)
						formula = formula + this.getItemValue(id);
					}
				}
				else{
					formula = formula + this.getItemValue(id);
				}
				
				
			}else {
				formula = formula + term[i];
			};
		};

		try{
			console.log(formula);
			result =  eval(formula);
			//console.log(result);
		}catch(e){
			//swal('Error', 'Verifique todos sus valores antes de calcular','error');
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
		
	}

	getItemValue(id){
		return document.getElementById(id).value;
	}

	calculateValuesSV(e){
		this.validateRangeSV(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');
//console.log(str)
				document.getElementById(this.state.biometrics[i].id).value = this.getTerms(str);

				this.validateRangeSV(this.state.biometrics[i].id, this.getTerms(str));
			};
		};

		if(e.target.value.indexOf('.') !== -1){
			this.setState({max_length: "5"});
		}else{
			this.setState({max_length: "4"});
		}
		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);

			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				if(control.required){
					control.classList.add('error');	
				}
				
			}
		}
	}

	validateRangeSV(id, value){
		for(var i =0; i < this.state.biometrics.length;i++){
			if(id.toString() === this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.donor_sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	saveVitalSigns(){
		if(this.isValidForm() === true){
			var temp = [];
			var value;
			for (var i = 0; i < this.state.biometrics.length; i++) {
				value = document.getElementById(this.state.biometrics[i].id).value;
				if (value !== "") {
					var obj = {};
					obj.biometrics_id = this.state.biometrics[i].id;
					obj.offers_id = this.state.biometrics[i].offer_id;

					if(i === 0){
						if(value.indexOf('.') !== -1){
							obj.value =  value;
						}else{
							var val = parseInt(value) / 100;
							obj.value = val;
						}
					}else{
						if (this.state.biometrics[i].data_type ==="BIO_D_SELECT") {
							obj.value_text = value;
						}else{
						obj.value =  value;
						}
					}

					
					temp.push(obj);
				};
					
			};

			var send = {};
			send.values = temp;
			send.offer_id = this.state.offer_id;
			send.type="BIO_F_SIGNOS";
			send.sample_valid = this.state.sample_valid;
			if(this.state.incident_refused_id === ""){
				send.incident_id = this.state.incident_type.id !== null && this.state.incident_type.id !== "" ?
									 parseInt(this.state.incident_type.id,10):0;
			}
			
			if(send.values.length > 0){//console.log(send)
				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+'biometrics_data', {
				  method: 'POST', // or 'PUT'
				  body: JSON.stringify(send), // data can be `string` or {object}!
				  headers: new Headers({
				  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				  	'Accept': 'application/json',
				  	'Content-Type': 'application/json;charset=UTF-8'
				  })
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}console.log(res)})
				.catch(error => console.error('Error:', error))
				.then(response => {
			    	if(response !== undefined){
			    		notify.show('Signos Vitales Guardados','success');
			    		this.handleClose();
			    		if(this.props.refresh !== undefined){
			    			this.props.refresh();
			    		}
			    	}else{
			    		swal('Error', 'No se pudo guardar','error');
			    	}
				});
			}else{
				swal('¡Error!', '¡No ha agregado ningun valor!', 'error');
			}
		}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		//const ctrls = document.querySelectorAll('input,select');
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input, select');
		
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		//console.log(refName+' is required');
		var res = null;
		var control = document.getElementById(refName);
		if (control.value === "") {
	        if(control !== null){
	            control.classList.add('error');
	        }
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
	    	}
			res = true;
		}

		return res;
	}

	acceptNum(e){//Sólo números y SÓLO 1 punto decimal
		if(e.key === 'Enter'){
			this.validateInput(e);
		}else{
			// Punto = 46
			var key = e.which;
			var cadena= e.target.value 
			if(cadena.indexOf('.')===-1){
				if(key <= 13 || (key >= 48 && key <= 57) || key == 46){
					
					return;
				}else{
					e.preventDefault();
				}
			
			}else{
				if(key <= 13 || (key >= 48 && key <= 57)){
					return;
				}else{
					e.preventDefault();
				}
			}
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}
	async printSvDocument(e){
		e.preventDefault();
		//this.props.waiting.handleShow('Imprimiendo...');
					 
		 var obj ={};
		 obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		 obj.id = this.state.offer_id;
		 obj.file_type = 'sv_results';
		 obj.nEtiqueta = [0];

		 var type = await this.props.getDocumentType(obj.file_type);
	     console.log(type);
		 var document;
		 if (type!=null) {
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			 }else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			 }
		 }
		 if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		 }else{
			this.props.waiting.handleClose();
		}
	}
	changeCombo(e,i){
		//if (form_type ==='BIO_F_SIGNOS') {
			var biometrics =this.state.biometrics;
			//console.log(biometrics);
			console.log(biometrics[i]);
			biometrics[i].value = e.target.value;
			//console.log(biometrics);
			this.setState({biometrics:biometrics});
		//}
		// if (form_type ==='BIO_F_BIO') {
		// 	var biometrics = this.state.biometrics;
		// biometrics[i].value = e.target.value;
		// this.setState({biometrics: biometrics});
		// }
	}
	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.vital_signs.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body style={{fontSize: "11px",}}>
		        	<form noValidate>
			        	<div className="row" >
							<div className="col-xs-12">
								<label style={{marginRight:8}}>Donador: </label>
								<span className="span-min">{this.state.donor_name}</span>
							</div>
							<div className="col-xs-6">
								<label style={{marginRight:8}}>Ofrecimiento: </label>
								<span className="span-min">{this.state.offer_number}</span>
							</div>
							<div className="col-xs-6">
								<label style={{marginRight:8}}>Fecha: </label>
								<span className="span-min">{this.state.offer_date}</span>
							</div>
			        		<div className="col-xs-12">
							<List>
			        				{
			        					this.state.biometrics.map( (t, index) => (
			        						<div className="col-xs-12 form-group" key={index}>
						        				<div className="col-xs-offset-2 col-xs-2" style={{padding:'0px'}}>
							        				<span>{t.name}:</span>
							        			</div>
												{t.data_type === 'BIO_D_SELECT' ? 
												<div className="col-xs-6 col-sm-3">
														<select name={t.id} id={t.id} 
															value={t.value} className="form-control"
															required={t.required}
															style={{padding:5}}
															onChange={(e)=>this.changeCombo(e, index)}
															disabled={this.state.isExtractionComplete || (!this.props.task_vital_signs.create && !this.props.task_vital_signs.update)||
																this.state.exist_extraction}
														>
															<option value="">Seleccionar...</option>
															{t.biometrics_options.map((option, i)=>
																<option value={option.value} key={i}>{option.value}</option>
															)}
														</select></div>:
							        			<div className="col-xs-6 col-sm-3">
													<input name={t.id} id={t.id} value={t.value} 
													style={{textAlign:'right'}}
													required={t.required}
													maxLength={this.state.max_length}
							        				onChange={(e) => this.calculateValuesSV(e)}
													onKeyPress={this.acceptNum}
							        				type="text" className="form-control"
							        				disabled={this.state.isExtractionComplete || t.data_type === "BIO_D_CALCULATED" || (
							        					this.state.option === 'save' ? !this.props.task_vital_signs.create : 
									        			this.state.option === 'update' ? !this.props.task_vital_signs.update :
									        			this.state.option === 'todos' ? false : true
							        				)}
							        				
													/>
							        			</div>}
												<div className="col-xs-4 col-sm-3">
													<span className="span-min">{t.units}</span>
												</div>
						        			</div>
										))
			        				}
			        			</List>

			        				<div className="col-xs-12 form-group">
								        <div className="col-xs-offset-2 col-xs-2" style={{padding:"0px"}}>
								        	<span>TIPO INCIDENTE:</span>
								       	</div>
								       	<div className="col-xs-6 col-sm-3">
											<select className="form-control" value={ this.state.incident_type.id || ""} 
									        	onChange={ this.onIncidentSelected } name="incident_type" id="incident_type" disabled={this.state.isExtractionComplete}>
								              	<option value="">Seleccionar...</option>
								                {
									                this.state.incidents_type.map(function(t) {
									                	return <option key={t.id} value={t.id} >{t.name}</option>;
									                })
								            	}
								            </select>
								        </div>
							        </div>
				 			</div>

						</div>
					</form>
		        </Modal.Body>
		        <Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.print')} onClick={(e) => this.printSvDocument(e)}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} keyboardFocused={false} onClick={this.saveVitalSigns} 
		        		disabled={this.state.option === 'save' ? !this.props.task_vital_signs.create : 
		        			this.state.option === 'update' ? !this.props.task_vital_signs.update :
		        			this.state.option === 'todos' ? false : true}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalVitalSigns) 